import { TenantSubdomain } from "features/types";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";
import { useEffect, useState } from "react";
import { Platform } from "react-native";
import { useAppSelector } from "./useAppSelector";

export default function useIsRunningInBallpark() {
  const [isRunningInBallpark, setIsRunningInBallpark] = useState(false);
  const { tenantSubdomain } = useAppSelector((state) => state.tenant);
  const { data: tenantConfig } = useFetchTenantConfigurationQuery();
  const MLB_TENANTS: TenantSubdomain[] = [
    "brewers",
    "rays",
    "astros",
    "marlins",
    "rangers",
  ];

  useEffect(() => {
    if (!tenantConfig || !tenantSubdomain) return;
    if (Platform.OS !== "web") setIsRunningInBallpark(false);
    // Upon inspecting the window object for our app when running inside Ballpark,
    // I found that the DatadogEventBridge global object is injected to the app.
    // @ts-ignore
    const hasBallparkInjectedObject = window.DatadogEventBridge !== undefined;
    const isMLBTenant = MLB_TENANTS.includes(tenantSubdomain);
    setIsRunningInBallpark(isMLBTenant && hasBallparkInjectedObject);
  }, [tenantConfig, tenantSubdomain]);

  return { isRunningInBallpark };
}
